export const SET_FORGOT_PASSWORD_COMPONENT = "SET_FORGOT_PASSWORD_COMPONENT";
